import CreateCustomArticle from '@/views/CreateCustomArticleView';

const slugs = [
  'about-us',
  'contact-us',
  'terms-and-conditions',
  'privacy-statement'
];

export default slugs.map((slug) => ({
    path: slug,
    name: `Footer-Article-${slug.toUpperCase()}`,
    component: CreateCustomArticle('mgto', slug)
}))